<template lang="pug">
#sub-empresa-tabela-gestao-contrato-originacao
    .tabela-gestao-contrato-originacao__tabela
        el-table(
            :key="listagemTableKey('subempresa-gestao-alvorada', tabelaData, paginacao.pagina + 1)",
            :data='tabelaData',
            v-loading='carregando',
            stripe,
            :default-sort='{ prop: "date", order: "descending" }',
            @sort-change='sortChangeRequest',
            style='width: 100%'
        )
            el-table-column(
                prop='numeroContrato',
                label='Nº do contrato',
                sortable='custom',
                min-width='10'
            )
            el-table-column(
                prop='materialNome',
                label='Cultura',
                sortable,
                min-width='10'
            )
            el-table-column(
                prop='safraAno',
                label='Safra',
                sortable='custom',
                min-width='7.5'
            )
            el-table-column(
                prop='dataContrato',
                label='Data do contrato',
                sortable='custom',
                min-width='10'
            )
            el-table-column(
                prop='volumeContratado',
                label='Volume vendido (t)',
                sortable='custom',
                min-width='10'
            )
                .template(slot-scope='scope')
                    span {{ scope.row.volumeContratado + ' t' }}
            el-table-column(label='Saldo restante (t)', min-width='10')
                .template(slot-scope='scope')
                    span {{ scope.row.saldoRestante + ' t' }}
            el-table-column(
                prop='clienteNomeRazaoSocial',
                label='Cliente',
                sortable,
                min-width='12.5'
            )
            el-table-column(
                prop='statusSubEmpresa',
                label='Status',
                sortable='custom',
                min-width='7.5'
            )
                .template(slot-scope='scope')
                    .status-processamento {{ scope.row.statusSubEmpresa }}
            el-table-column(label='Ações', align='center', min-width='5')
                .template.d-flex.justify-content-center.tabela-gestao-icone(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                v-if='scope.row.statusSubEmpresaCodigo !== "AGUARDANDO_PREENCHIMENTO"',
                                @click.native='visualizarProcessamento(scope.row.numeroContrato)'
                            ) {{ $t('mensagens.subEmpresaGestao.tabela.acoes.visualizar') }}
                            el-dropdown-item(
                                icon='el-icon-edit',
                                v-if='codigosPreencher[scope.row.statusSubEmpresaCodigo]',
                                @click.native='irParaContrato(scope.row.numeroContrato)'
                            ) {{ $t('mensagens.subEmpresaGestao.tabela.acoes.preencher') }}
                            el-dropdown-item(
                                icon='el-icon-edit',
                                v-if='codigosEdicao[scope.row.statusSubEmpresaCodigo]',
                                @click.native='irParaContrato(scope.row.numeroContrato)'
                            ) {{ $t('mensagens.subEmpresaGestao.tabela.acoes.editar') }}
                            el-dropdown-item(
                                v-if='scope.row.statusSubEmpresaCodigo === "CONCLUIDO"',
                                @click.native='exportarRelatorioRastreabilidade(scope.row.numeroContrato)'
                            )
                                i.mdi.mdi-file-document-multiple-outline
                                span {{ $t('mensagens.subEmpresaGestao.tabela.ExportarRelatorioRastreabilidade') }}
                            el-dropdown-item(
                                v-if='scope.row.statusSubEmpresaCodigo === "CONCLUIDO"',
                                @click.native='exibirModalCompartilhamentoRelatorioRastreabilidade(scope.row.numeroContrato)'
                            )
                                i.mdi.mdi-share-variant-outline
                                span {{ $t('mensagens.subEmpresaGestao.tabela.compartilharRelatorioRastreabilidade') }}

            template(slot='empty')
                el-empty(
                    :description='$t("mensagens.subEmpresaGestao.tabela.acoes.semDados")'
                )

    .tabela-gestao-contrato-originacao__paginacao
        span.pagina
            | {{ paginacao.total }} {{ paginacao.total > 1 ? $t('mensagens.subEmpresaGestao.tabela.acoes.contratos') : $t('mensagens.subEmpresaGestao.tabela.acoes.contrato') }}

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )

    .modal-compartilhamento-relatorio
        ModalCompartilhamentoRelatorioRastreabilidade(
            ref='modalCompartilhamentoRelatorioRastreabilidade',
            :show='mostrarModalCompartilhamentoRelatorioRastreabilidade',
            :numeroContrato='numeroContratoSelecionado',
            @enviarEmail='compartilharRelatorioRastreabilidadePorEmail',
            @voltar='mostrarModalCompartilhamentoRelatorioRastreabilidade = false'
        )
</template>

<script>
import ModalDetalheAnalise from '@/components/contratosOriginacao/ModalDetalheAnalise.vue';
import { mapGetters } from 'vuex';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import ModalCompartilhamentoRelatorioRastreabilidade from './ModalCompartilhamentoRelatorioRastreabilidade.vue';

export default {
    name: 'SubEmpresaTabelaGestaoContratoOriginacaoAlvorada',
    components: {
        ModalDetalheAnalise,
        ModalCompartilhamentoRelatorioRastreabilidade
    },
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            codigosPreencher: {
                AGUARDANDO_PREENCHIMENTO: 'AGUARDANDO_PREENCHIMENTO'
            },
            codigosEdicao: {
                EM_CADASTRAMENTO: 'EM_CADASTRAMENTO',
                EM_PROCESSAMENTO: 'EM_PROCESSAMENTO',
                EM_ANDAMENTO_VOLUME_INCONPLETO:
                    'EM_ANDAMENTO_VOLUME_INCONPLETO',
                EM_ANDAMENTO_REQUER_ATENCAO: 'EM_ANDAMENTO_REQUER_ATENCAO',
                EM_ANDAMENTO_AGUARDANDO_ENVIO: 'EM_ANDAMENTO_AGUARDANDO_ENVIO'
            },
            visualizaAnalise: {
                PROCESSADO: 'PROCESSADO'
            },
            mostrarModalCompartilhamentoRelatorioRastreabilidade: false,
            numeroContratoSelecionado: '',
            notificacaoCompartilharRelatorio: null
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    methods: {
        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },
        sortChangeRequest(column) {
            const order = {
                prop: column.prop,
                order: column.order === 'ascending' ? 'asc' : 'desc'
            };

            this.$emit('ordenarTabela', order);
        },
        visualizarProcessamento(numeroContrato) {
            this.$router.push({
                name: 'VisualizarProcessamentoContratoOriginacao',
                params: { numeroContrato }
            });
        },

        async irParaContrato(numeroContrato) {
            this.$router.push({
                name: 'PreencherContratoOriginacao',
                params: { numeroContrato }
            });
        },

        async exportarRelatorioRastreabilidade(numeroContrato) {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.tabela.downloadPDF'
                    )
                });
                return;
            }

            if (this.usuarioLogado) {
                try {
                    subscribe(
                        `${this.usuarioLogado.idKeyCloack}/contrato-originacao/relatorio-rastreabilidade-subempresa/pdf`,
                        response => {
                            if (response) {
                                const linkSource = `data:application/pdf;base64,${response}`;
                                const link = document.createElement('a');
                                const fileName = `relatorio-rastreabilidade-${numeroContrato}.pdf`;
                                link.href = linkSource;
                                link.download = fileName;
                                document.body.append(link);
                                link.click();
                                link.remove();
                            } else {
                                this.$notify.error({
                                    message: this.$t(
                                        'mensagens.subEmpresaGestao.tabela.relatorioRastreabilidade'
                                    )
                                });
                            }
                            this.fecharNotificacaoCompartilharRelatorio();
                            disconnect();
                        }
                    );

                    ContratoOriginacaoService.exportarPdfRelatorioRastreabilidadeSubempresa(
                        numeroContrato
                    );

                    this.notificacaoCompartilharRelatorio = this.$notify({
                        message:
                            '<i class="el-icon-loading" style="font-size: 20px; color: #043c5a;"></i> O download do relatório está sendo processado!',
                        duration: 600000,
                        dangerouslyUseHTMLString: true,
                        showClose: false
                    });
                } catch (error) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.tabela.relatorioRastreabilidade'
                        )
                    });
                    this.fecharNotificacaoCompartilharRelatorio();
                    disconnect();
                }
            } else {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.tabela.usuarioDeslogado'
                    )
                });
                disconnect();
            }
        },
        exibirModalCompartilhamentoRelatorioRastreabilidade(numeroContrato) {
            this.numeroContratoSelecionado = numeroContrato;
            this.mostrarModalCompartilhamentoRelatorioRastreabilidade = true;
        },
        fecharNotificacaoCompartilharRelatorio() {
            if (this.notificacaoCompartilharRelatorio) {
                this.notificacaoCompartilharRelatorio.close();
            }
        },
        compartilharRelatorioRastreabilidadePorEmail(email) {
            try {
                ContratoOriginacaoService.compartilharRelatorioRastreabilidadeSubempresa(
                    this.numeroContratoSelecionado,
                    email
                ).then(() => {
                    this.fecharNotificacaoCompartilharRelatorio();
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.tabela.emailSucesso'
                        )
                    });
                });
                this.$refs.modalCompartilhamentoRelatorioRastreabilidade.fecharModal();
                this.notificacaoCompartilharRelatorio = this.$notify.info({
                    message:
                        '<i class="el-icon-loading" style="font-size: 20px; color: #043c5a;"></i> O e-mail está sendo enviado!',
                    dangerouslyUseHTMLString: true
                });
            } catch (erro) {
                this.$notify.error({
                    message: erro.response.data.message
                });
            }
        }
    }
};
</script>
<style lang="scss">
#sub-empresa-tabela-gestao-contrato-originacao {
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);
    border-radius: 10px;

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
        thead.has-gutter {
            height: 67px;
            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }
    .el-table__cell {
        font-size: 12px;
    }
    .is-leaf {
        font-size: 13px;
    }
    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }
    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }
    .tabela-gestao-icone {
        i {
            font-size: 23px;
            cursor: pointer;
        }
    }
}
</style>
